module.exports = __webpack_public_path__ + "img/contact-form.e5f1fa5e.png";